<template>
  <div id="liveConsole" class="liveconsole" v-if="isReady">
    <b-loading v-model="isLoading"></b-loading>
    <div class="columns liveconsole__inner">
      <div class="column">
        <div class="video">
          <div class="video__inner">
            <OpenVideo :liveUrl="playbackUrl" :thumbnailURL="thumbnailURL" v-if="mode == MODE.OPEN"/>
            <IndividualVideo ref="individualVideo" :thumbnailURL="thumbnailURL" v-if="mode == MODE.INDIVIDUAL" isCast/>
          </div>
        </div>
        <div class="information">
          <div class="information__data" v-if="mode == MODE.OPEN">配信時間：{{ duration ? duration : '00:00:00' }} 視聴数：{{ patronCount }}人</div>
        </div>
        <ReserveList :liveId="liveId" @reserveList="setReserveList" isCast />
        <div class="liveparts">
          <div class="panel">
            <div class="buttons">
              <button type="button" v-if="hasReserve" class="switchButton" @click="changeNextLive">
                次の配信に切り替える
              </button>
              <button type="button" class="endButton" @click="endOpenStreaming">
                <img class="icon" src="@/assets/image/btn_start_streaming.png"/>配信終了
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-one-third-desktop">
        <Chat style="height:80%" :params="chatParams" ref="chat" isCast/>
      </div>
    </div>
    
  </div>
</template>

<script>
import * as reserveServices from '@/services/reserveServices';
import * as doronServices from '@/services/doronServices';
import * as DateTime from '@/utils/date';
import OpenVideo from '@/components/Video';
import IndividualVideo from '@/components/ChimeVideo';
import Chat from '@/components/Chat';
import ReserveList from '@/components/ReserveList';
import { firebase } from '@/plugins/firebase';
import moment from 'moment';
import * as modal from '@/utils/modal';
import { analyticsLog } from '@/utils/analytics';

const functions = firebase.app().functions('asia-northeast1');

const MODE = {
  OPEN: "open",
  INDIVIDUAL: "individual"
}

export default {
  name: 'LiveConsole',
  components: {
    OpenVideo,
    IndividualVideo,
    Chat,
    ReserveList
  },
  computed: {
    title() {
      return this.$store.state.live.recentLive.title;
    },
    nowReserveId() {
      return this.$store.state.live.recentLive.nowReserveId;
    },
    isPerformer() {
      return this.$store.getters['user/isPerformer'];
    },
    isStreaming() {
      return this.$store.getters['user/isStreaming'];
    },
    ableStartStreaming() {
      return this.$store.getters['ivs/ableStartStreaming'];
    },
    ableEndStreaming() {
      return this.$store.getters['ivs/ableEndStreaming'];
    },
    streamKey() {
      return this.$store.state.ivs.streamKey.value;
    },
    playbackUrl() {
      return this.$store.state.ivs.channel.playbackUrl;
    },
    ingestEndpoint() {
      return this.$store.state.ivs.channel.ingestEndpoint
        ? `rtmps://${this.$store.state.ivs.channel.ingestEndpoint}:443/app/`
        : '';
    },
    disableNextButton() {
      return !(this.nextReserve && this.nextReserve.allowSwitch);
    },
    disableEndButton() {
      return !(this.ableEndStreaming && this.isStreaming);
    },
    thumbnailURL() {
      if (this.$route.query.type == 'upComingLive') {
        return this.$store.state.live.upComingLive.thumbnailURL;
      } else if (this.$route.query.type == 'recentLive') {
        return this.$store.state.live.recentLive.thumbnailURL;
      }
      return '';
    },
    chatParams() {
      return {
        liveId: this.nowReserveId ? this.liveId + "_" + this.nowReserveId : this.liveId,
        myPhotoURL: null,
        isRecentLive: true,
        commentDisabled: true
      }
    },
  },
  data() {
    return {
      isReady: false,
      MODE: MODE,
      mode: MODE.OPEN,
      userData: null,
      ivsChannelInfo: {},
      liveId: this.$route.params.liveId,
      reserveList: [],
      hasReserve: false,
      nowReserve: null,
      nextReserve: null,
      patronCount: 0,
      comments: [],
      donations: [],
      startAt: null,
      duration: null,
      intervalId: null,
      getStreamIntervalId: null,
      countUpIntervalId: null,
      isLoading: false
    };
  },
  async created() {
    if (!this.$route.params.liveId) {
      this.$router.replace(`/live/expired/${this.$store.state.auth.uid}`);
      return;
    }

    let liveId = this.$route.params.liveId;
    await this.$store.dispatch('live/loadRecentLive', liveId);

    if (!this.$store.state.live.recentLive) {
      this.$router.replace(`/live/expired/${this.$store.state.auth.uid}`);
      return;
    }

    this.hasReserve = await reserveServices.hasReserve(this.$route.params.liveId);
    if (this.hasReserve) {await this.setReserveList();}

    this.isReady = true;

    let nowReserve = this.findNowReserve();
    setTimeout(async () => {
      if (nowReserve) {
        await this.startIndividualStreaming(nowReserve);
      } else {
        await this.startOpenStreaming();
      }
    }, 1000);
  },
  methods: {
    scrollToEnd() {
      const container = document.querySelector('.comment__display');
      container.scrollTop = container.scrollHeight;
    },
    async resetStreamKey() {
      try {
        this.$store.dispatch('resetStreamKey', {
          userId: this.$store.state.auth.uid,
          channelArn: this.$store.state.user.ivsChannelArn,
          streamKeyArn: this.$store.state.user.ivsStreamKeyArn
        });
        this.$buefy.toast.open({
          message: 'ストリームキーがリセットされました。',
          type: 'is-success'
        });
      } catch (err) {
        console.error(err);
        return;
      }
    },
    async changeNextLive() {
      await this.setReserveList();

      if (this.nextReserve && this.nextReserve.reserver && !this.nextReserve.allowSwitch) {
        modal.alert(this, "配信切り替えエラー", "次の配信は、開始1分前より<br/>切り替え可能です。");
        return;
      }
      if (this.mode == MODE.OPEN && (!this.nextReserve || !this.nextReserve.reserver)) {
        return;
      }
      modal.confirm(this, "配信切り替え", "次の配信に切り替えます。<br/>よろしいですか？", null, async () => await this.execChangeNextLive());
    },
    async execChangeNextLive() {
      let nextReserve = null;
      if (this.nextReserve && this.nextReserve.reserver) {
        nextReserve = this.nextReserve;
      }

      this.isLoading = true;

      if (this.nowReserveId) {
        await this.endIndividualStreaming();
      } else {
        await this.resumeOpenStreaming();
      }
      
      if (nextReserve) {
        await this.startIndividualStreaming(nextReserve);
      } else {
        await this.startOpenStreaming();
      }

      this.isLoading = false;
    },
    async startOpenStreaming() {
      this.mode = MODE.OPEN;
      this.getStream(this.$store.state.ivs.channel.arn);
      this.getStreamIntervalId = setInterval(async () => {
        await this.getStream(this.$store.state.ivs.channel.arn);
      }, 3000);

      this.intervalId = setInterval(() => {
        if (!this.startAt) return;
        this.duration = moment().subtract(this.startAt).format('HH:mm:ss');
      }, 1000);

      this.loadComment();
    },
    async allowEndOpenStreaming() {
      if (!this.reserveList || this.reserveList.length == 0) {
        return true;
      }

      return (await DateTime.serverDate()).toJSDate() >= this.reserveList.slice(-1)[0].endAt
    },
    async endOpenStreaming() {
      await this.setReserveList();

      if (!await this.allowEndOpenStreaming()) {
        modal.alert(this, "配信切り替えエラー", "この配信は、限定配信時間が終了していないため<br/>終了できません。");
        return;
      }

      modal.confirm(this, "配信終了", "この配信を終了します。<br/>よろしいですか？", null, async () => await this.execEndOpenStreaming());
    },
    async execEndOpenStreaming() {
      this.isLoading = true;

      try {
        if (this.mode == MODE.INDIVIDUAL) {
          await this.endIndividualStreaming();
          this.mode == MODE.OPEN;
        }

        await this.$store.dispatch('endStreaming', {
          channelArn: this.$store.state.ivs.channel.arn,
          userId: this.$store.state.auth.uid,
          liveId: this.$route.params.liveId,
          liveDoc: this.$store.state.live.recentLive
        });
        clearInterval(this.intervalId);
        clearInterval(this.getStreamIntervalId);

        this.$buefy.dialog.alert({
          message: `配信ツールから配信を終了してください`,
          confirmText: 'はい',
          type: 'is-danger',
          onConfirm: () => {
            this.$router.push('/cast/mypage/liveSchedule');
          }
        });
        this.commentRefObj = {};
      } catch (err) {
        console.error(err);
        return;
      } finally {
        this.isLoading = false;
      }
    },
    async resumeOpenStreaming() {
      try {
        clearInterval(this.intervalId);
        clearInterval(this.getStreamIntervalId);

        modal.alert(this, "", "限定配信に切り替えました。OBS等ツールの配信は終了し、仮想カメラのみONにしてください。再度フリー配信に切り替える時は、ツールの配信を開始してください。", async () => {
          const stopStream = functions.httpsCallable('stopStream');
          await stopStream({ channelArn: this.$store.state.ivs.channel.arn });
          this.commentRefObj = {};
        });
      } catch (err) {
        console.error(err);
        return;
      }
    },
    async startIndividualStreaming(reserve) {
      this.mode = MODE.INDIVIDUAL;

      setTimeout(async () => {
        try {
          if (this.$refs.individualVideo) await this.$refs.individualVideo.startMeeting();

          for (var doc of reserve.docList) {
            await this.$store.dispatch('startReserveLive', {
              liveId: this.$route.params.liveId,
              reserveDocId: doc.id,
              reserveId: reserve.reserveId
            });
          }

          this.loadComment();
          this.nowReserve = reserve;

          this.countUpIntervalId = setInterval(() => {
            this.countUp();
          }, 60000)
        } catch (err) {
          console.error(err);
          return;
        }
      }, 1000);
    },
    async endIndividualStreaming() {
      if (!this.nowReserve) return;
      try {
        let price = await this.calcPrice();
        await this.$refs.individualVideo.deleteMeeting();
        for (var doc of this.nowReserve.docList) {
          await this.$store.dispatch('endReserveLive', {
            liveId: this.$route.params.liveId,
            reserveId: doc.id
          });
        }

        clearInterval(this.countUpIntervalId);
        await this.purchase(this.nowReserve.reserver, price);

        this.commentRefObj = {};
        this.nowReserve = null;
      } catch (err) {
        console.error(err);
        return;
      }
    },
    async loadComment() {
      this.commentRefObj = await this.$refs.chat.readComment();
    },
    async getStream(channelArn) {
      if (!channelArn) return;
      const getStream = functions.httpsCallable('getStream');
      const response = await getStream({
        channelArn: channelArn
      });
      if (response.data.httpErrorCode) return;
      if (!this.startAt)
        this.startAt = moment.unix(response.data.startTime.toLocaleString());
      this.patronCount = response.data.viewerCount > 0 ? response.data.viewerCount - 1 : 0;
    },
    async setReserveList() {
      let liveId = this.$route.params.liveId;
      this.reserveList = await reserveServices.getMargedReserve(liveId);
      this.nextReserve = await this.getNextReserve();
    },
    async getNextReserve() {
      if (!this.reserveList || !this.reserveList.length > 0) {
        return null;
      }

      let criterionDate = (await DateTime.serverDate()).toJSDate();
      criterionDate.setMinutes(criterionDate.getMinutes() + 1);

      for (let doc of this.reserveList) {
        if (
          ( ( this.nowReserveId && doc.status == reserveServices.STATUS.OPEN )
            || doc.status == reserveServices.STATUS.RESERVED )
          && criterionDate < doc.endAt) {
          doc["allowSwitch"] = criterionDate >= doc.startAt;
          return doc;
        }
      }
      
      return null;
    },
    findNowReserve() {
      if (!this.reserveList || !this.nowReserveId) {
        return null;
      }
      for (let reserve of this.reserveList) {
        if (reserve.reserveId == this.nowReserveId) {
          return reserve;
        }
      }
      return null;
    },
    async countUp() {
      if (!this.nowReserve || !this.nowReserve.docList) {
        return;
      }

      let criterionDate = (await DateTime.serverDate()).toJSDate();
      for (let doc of this.nowReserve.docList) {
        if (doc.startAt <= criterionDate && criterionDate < doc.endAt) {
          let newDoc = await reserveServices.countUp(doc);
          if (newDoc) doc.point = newDoc.point;
          break;
        }
      }
    },
    async calcPrice() {
      await this.setReserveList();
      let target = this.findNowReserve();
      if (!target) return -1;

      let point = 0;
      for (let doc of target.docList) point += doc.point;

      return point;
    },
    async purchase(uid, price) {
      await this.$store.dispatch('doron/purchaseByCast', {
        userId: uid,
        price: price
      });
      await doronServices.addPurchaseHistory(doronServices.PURCHASE_KIND.INDIVIDUAL_LIVE, uid, this.$store.state.auth.uid, this.$route.params.liveId, doronServices.TYPE.PAID, price);
      analyticsLog('限定配信ポイント消費完了【動作完了】', {'消費G数': price});
    }
  },
  beforeDestroy() {
    clearInterval(this.countUpIntervalId);
    clearInterval(this.intervalId);
    clearInterval(this.getStreamIntervalId);
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-console.scss';
</style>
